import { Helmet } from "react-helmet";
import RandingStyle11 from "../../randing/RandingStyle11";

function Randing071({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "4185c549-c636-4fb4-b787-1e6c2baa37fe", label: "치아교정" },
    { value: "9ef6b072-7256-45ed-9465-a58308a69c3a", label: "심미치료" },
  ];
  return (
    <>
      <Helmet>
        <title>검뉴치 교정 할인 이벤트</title>
      </Helmet>
      <RandingStyle11
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/071/25011301.png`}
        formFieldColor="white"
        privacyMessage="개인정보 수집 및 이용 동의"
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/sky/consultApplyButton.png`}
        companyName="검단뉴욕치과"
        isCallInsideContactBox={false}
        isKakaoInsideContactBox={false}
        isFixedCallIcon={false}
        isFixedKakaoIcon={false}
        fixedDbColor={"#3c3c3c"}
        articleOption={true}
        treatments={treatments}
        benefitInfo={false}
        redirectUrl="http://검단뉴욕치과.com/"
        kakaotalk="003"
      />
    </>
  );
}

export default Randing071;
